import { Injectable } from '@angular/core';
import { AppConfigService } from '../../../config/app-config.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class HrAuthServiceService {
  baseUrl: string;
  private hrUnlockedKey = 'hrToken';

  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient
  ) {
    // this.baseUrl = this.appConfigService.getApiBaseUrl();
    this.baseUrl = this.appConfigService.getApiGatewayBaseUrl();
  }

  hrlogin(data: any) {
    return this.http.post(`${this.baseUrl}/api/UserAuth/LogInHRLink`, data);
  }

  verifyOtp(data: any) {
    return this.http.post(
      `${this.baseUrl}/api/UserAuth/VerifyHRLinkLogin`,
      data
    );
  }

  hrloginmodal(data: any) {
    return this.http.post(`${this.baseUrl}/api/CompanyAdmins/hr-link/login/re-verify`, data);
  }

  /**
   * Clear HR session data (tokens and related information)
   * This method only clears HR-specific tokens, not the main session token
   */
  // clearHrSession(): void {
  //   // Remove HR-specific tokens only
  //   sessionStorage.removeItem('hrToken');
  //   sessionStorage.removeItem('hrEmployerId');

  //   // Don't remove the main token and employerId as they're used for other parts of the app
  //   // sessionStorage.removeItem('token');
  //   // sessionStorage.removeItem('employerId');

  //   console.log('HR session cleared successfully');
  // }

  /**
   * Store HR-specific token in sessionStorage
   */
  storeToken(token: string): void {
    // Store both as main token and HR-specific token
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('hrToken', token);
  }

  /**
   * Retrieve token
   */
  getToken(): string | null {
    return sessionStorage.getItem('token');
  }

  /**
   * Get HR-specific token
   */
  getHrToken(): string | null {
    return sessionStorage.getItem('hrToken');
  }

  /**
   * Check if HR is logged in
   */
  isHrLoggedIn(): boolean {
    return !!this.getHrToken();
  }

  /**
   * Check if user is logged in (general)
   */
  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  /**
   * Clear token on logout
   */
  clearToken(): void {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('hrToken');
  }

  /**
   * Store employer ID in sessionStorage
   */
  storeEmployerId(employerId: string): void {
    sessionStorage.setItem('employerId', employerId);
    sessionStorage.setItem('hrEmployerId', employerId);
  }

  /**
   * Retrieve employer ID
   */
  getEmployerId(): string | null {
    return sessionStorage.getItem('employerId');
  }

  /**
   * Get HR-specific employer ID
   */
  getHrEmployerId(): string | null {
    return sessionStorage.getItem('hrEmployerId');
  }

  /**
   * Clear employer ID on logout
   */
  clearEmployerId(): void {
    sessionStorage.removeItem('employerId');
    sessionStorage.removeItem('hrEmployerId');
  }

  /**
   * Full logout - clears everything
   */
  logout() {
    sessionStorage.clear(); // Clear everything
  }

  /**
   * Check if HR access is currently unlocked
   */
  // isHrUnlocked(): boolean {
  //   const hrToken = this.getHrToken();
  //   const email = sessionStorage.getItem('email');
  //   return !!(hrToken && email);
  // }

  // ==========
  /**
 * Check if HR is currently unlocked
 */
  isHrUnlocked(): boolean {
    try {
      const hrToken = sessionStorage.getItem(this.hrUnlockedKey) ||
        sessionStorage.getItem(this.hrUnlockedKey);
      return !!hrToken;
    } catch (error) {
      //console.error('Error checking HR unlock status:', error);
      return false;
    }
  }

  /**
   * Set HR unlock status
   */
  setHrUnlocked(isUnlocked: boolean): void {
    try {
      if (isUnlocked) {
        // Set a token to indicate HR is unlocked
        const token = 'hr-authenticated-' + Date.now();
        sessionStorage.setItem(this.hrUnlockedKey, token);
      } else {
        // Remove tokens to indicate HR is locked
        sessionStorage.removeItem(this.hrUnlockedKey);
        sessionStorage.removeItem(this.hrUnlockedKey);
      }
    } catch (error) {
      //console.error('Error setting HR unlock status:', error);
    }
  }

  /**
   * Clear HR session data
   */
  clearHrSession(): void {
    try {
      sessionStorage.removeItem(this.hrUnlockedKey);
      sessionStorage.removeItem('hrEmployerId');
      sessionStorage.removeItem('showHrLockModal');
      sessionStorage.removeItem(this.hrUnlockedKey);

      //console.log('HR session cleared');
    } catch (error) {
      //console.error('Error clearing HR session:', error);
    }
  }
}